const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M9.152 0q0.224 0 0.384 0.16t0.192 0.416v26.272q0 0.352-0.32 0.512l-8.576 4.576q-0.128 0.064-0.256 0.064-0.224 0-0.416-0.16t-0.16-0.416v-26.272q0-0.352 0.32-0.512l8.544-4.576q0.128-0.064 0.288-0.064zM31.424 0q0.224 0 0.416 0.16t0.16 0.416v26.272q0 0.352-0.288 0.512l-8.576 4.576q-0.128 0.064-0.288 0.064-0.224 0-0.384-0.16t-0.192-0.416v-26.272q0-0.352 0.32-0.512l8.576-4.576q0.128-0.064 0.256-0.064zM11.424 0q0.16 0 0.256 0.064l9.152 4.544q0.32 0.192 0.32 0.544v26.272q0 0.224-0.192 0.416t-0.384 0.16q-0.16 0-0.256-0.064l-9.152-4.544q-0.32-0.192-0.32-0.544v-26.272q0-0.224 0.192-0.416t0.384-0.16z"
});

const SvgMap = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-map",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map.2fa5e8a2.svg";
export { ForwardRef as ReactComponent };